import { enterpriseSystems } from "../data/servicesData";

function EnterpriseServiceGrid() {
  return (
    <div className="enterprise-grid">
      {enterpriseSystems.map((system) => (
        <article className="enterprise-card" key={system.id}>
          <div className="enterprise-card__icon" aria-hidden="true">
            <i className={`bi ${system.icon}`} />
          </div>
          <h3 className="enterprise-card__title">{system.title}</h3>
          <p className="enterprise-card__desc">{system.description}</p>
          <ul className="enterprise-card__features">
            {system.features.map((feature) => (
              <li key={feature}>
                <i className="bi bi-check-lg" />
                {feature}
              </li>
            ))}
          </ul>
        </article>
      ))}
    </div>
  );
}

export default EnterpriseServiceGrid;
